module.exports = __webpack_public_path__ + "img/img_kuaqu_c.903ed37b.png";